<template>
  <div v-if="!ShowType">
    <div
      v-if="albumSwitch"
      class="callback float"
      @click="onClick"
      @mousedown="down"
      @touchstart="down"
      @mousemove="move"
      @touchmove="move"
      @mouseup="end"
      @touchend="end"
      ref="fu"
    >
      <img @click="deletebox" class="z-indeximg" src="https://image.xiaomaiketang.com/xm/internal/SnzX8N543e.png" />
      <div @click="callback">
        <img :src="url" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DraggableComponent',

  props: {
    ShowType: {
      type: Boolean,
      default: true,
    },
    routers: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      flags: false, //控制使用
      imgbg:'https://image.xiaomaiketang.com/xm/internal/fzse5H4E75.gif',
      position: {
        x: 0,
        y: 0,
      },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      xPum: '',
      yPum: '',
      albumSwitch: false,
      url:"https://res.xiaomai5.com/album_print/banner_parent/album.gif",
      path: '',
    };
  },

  methods: {
    getAlbumList() {
      axios.Customer('public/dist/showGoodsType').then(res => {
        const { result } = res;
        if(result==='CALENDAR_PRINT'){
          this.url='https://res.xiaomai5.com/album_print/banner_parent/calendars_guide.png';
        }
        this.albumSwitch = result?true:false;
        if(result){
          this.getPath();
        }
      });
    },
    getPath() {
      let params = {
        path: 'pages/album/list/list',
        parameter: window.LS.getItem('weixin_phone') ||
        '',
      };
      axios.Zeus('anon/distAlbum/generatescheme', params).then(res => {
        this.path = res.result;
      });
    },
    callback() {
      // console.log('我是跳转功能');
      window.traceLog('C_CLICK_SERVICE_CommemorativeAlbumFloatingWindowAdvertisement', 'h5-点击-服务-纪念册浮窗广告');
      location.href = `${this.path}`;
    },
    deletebox() {
      // console.log('我是删除功能');
      this.$emit('showRight');
      window.CK.setCookie('album-operate-tip', true, 60 * 60 * 24 * 30);
    },
    onRefresh() {
      // window.location.reload();
      setTimeout(res => {
        console.log(res);
        this.isLoading = false;
      }, 1000);
    },
    down() {
      this.flags = true;
      let touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.fu.offsetLeft;
      this.dy = this.$refs.fu.offsetTop;
    },
    move() {
      if (this.flags) {
        let touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        let width = window.innerWidth - this.$refs.fu.offsetWidth; //屏幕宽度减去自身控件宽度
        let height = window.innerHeight - this.$refs.fu.offsetHeight; //屏幕高度减去自身控件高度
        this.xPum < 0 && (this.xPum = 0);
        this.yPum < 0 && (this.yPum = 0);
        this.xPum > width && (this.xPum = width);
        this.yPum > height && (this.yPum = height);
        // if (this.xPum >= 0 && this.yPum >= 0 && this.xPum<= width &&this.yPum<= height) {
        this.$refs.fu.style.left = this.xPum + 'px';
        this.$refs.fu.style.top = this.yPum + 'px';
        // }
        //阻止页面的滑动默认事件
        document.addEventListener(
          'touchmove',
          function() {
            event.preventDefault();
          },
          false,
        );
      }
    },
    //鼠标释放时候的函数
    end() {
      this.flags = false;
    },
    onClick() {
      this.$emit('click');
    },
  },
  activated() {
    // console.log(window.location, '+++++++++++++++++');
    // console.log(this.routers, '+++++++++++++++++++++');
  },
  mounted() {
    this.getAlbumList();
  },
};
</script>

<style lang="less" scoped>
.callback img {
  position: absolute;
  width: 0.24rem;
  height: 0.24rem;
  right: 0;
  top: 0;
}
.z-indeximg {
  position: absolute;
  width: 0.24rem;
  height: 0.24rem;
  right: 0;
  top: 0;
  z-index: 999999;
}
.callback div {
  width: 1.4rem;
  height: 1.4rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.callback div p {
  font-size: 0.22rem;
  font-weight: 400;
  color: #ffffff;
  line-height: 1;
}
.callback {
  position: fixed;
  top: 60px;
  right: 0px;
  z-index: 99999;
}
.float {
  position: fixed;
  right: 10px;
  top: 70%;
  touch-action: none;
  text-align: center;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.12rem;
  line-height: 0.24rem;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/module/DraggableComponent/index.vue